/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Lista dei dispositivi con passkey registrate
 */
export interface PasskeyDeviceInfo { 
    /**
     * Credential ID (Base64URL encoded)
     */
    credential_id: string;
    /**
     * Nome descrittivo del dispositivo
     */
    display_name?: string;
    /**
     * Data di registrazione
     */
    registered_at: Date;
    /**
     * Data di scadenza
     */
    expires_at: Date;
    /**
     * Ultimo utilizzo
     */
    last_used_at?: Date;
}